/** DNI pool GraphQL operations. Result types are inferred from the selection sets. */

import { graphql } from 'app/generated/gql'

export const DNI_POOL_NUMBERS_QUERY = graphql(`
  query DniPoolNumbers($dniId: ID!) {
    dniPoolNumbers(dniId: $dniId) {
      phone
      createdDate
    }
  }
`)

export const DNI_INTEGRATION_STATUS_QUERY = graphql(`
  query DniIntegrationStatus($locationId: ID!) {
    integrationStatus(integration: "dynamic number insertion", locationId: $locationId) {
      status
    }
  }
`)
